import React, { useState, useEffect } from "react";
import { Modal } from "../../Shared/Modal";

const ProductCheckOut = () => {
  const [billing, setBilling] = useState({
    name: "",
    email: "",
    address: "",
  });

  const [isModalSuccessOpen, setIsModalSuccessOpen] = useState(false);

  const handleChange = (e) => {
    setBilling({ ...billing, [e.target.name]: e.target.value });
  };

  const handlePlaceOrder = (e) => {
    e.preventDefault();

    // Validation: Check if all fields are filled
    if (!billing.name || !billing.email || !billing.address) {
      return; // No alert, just prevent submission
    }

    // Show success modal
    setIsModalSuccessOpen(true);

    // Reset form
    setBilling({
      name: "",
      email: "",
      address: "",
    });
  };

  const [products, setProducts] = useState([]);

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setProducts(storedCart);
  }, []);

  if (products.length === 0) {
    return (
      <p className="text-center p-6 text-gray-600">No products in cart.</p>
    );
  }

  const totalAmount = products.reduce(
    (sum, p) => sum + p.base_price * (p.quantity || 1),
    0
  );

  return (
    <div className="checkout-page max-w-4xl mx-auto p-6 relative">
      <h2 className="text-2xl font-bold mb-6">Checkout</h2>

      <div className="flex flex-col md:flex-row gap-6">
        {/* Order Summary */}
        <div className="flex-1 bg-white p-4 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-4">Order Summary</h3>
          {products.map((p) => (
            <div key={p.id} className="flex justify-between border-b py-2">
              <span>
                {p.name} x {p.quantity}
              </span>
              <span>${p.base_price * p.quantity}</span>
            </div>
          ))}
          <div className="flex justify-between font-semibold text-lg mt-4">
            <span>Total:</span>
            <span>${totalAmount}</span>
          </div>
        </div>

        {/* Billing Form */}
        <div className="flex-1 bg-white p-4 rounded-lg shadow">
          <h3 className="text-xl font-semibold mb-4">Billing Details</h3>
          <form className="space-y-4" onSubmit={handlePlaceOrder}>
            <input
              type="text"
              name="name"
              value={billing.name}
              onChange={handleChange}
              placeholder="Name"
              required
              className="w-full border rounded-lg p-2"
            />

            <input
              type="email"
              name="email"
              value={billing.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className="w-full border rounded-lg p-2"
            />

            <input
              type="text"
              name="address"
              value={billing.address}
              onChange={handleChange}
              placeholder="Address"
              required
              className="w-full border rounded-lg p-2"
            />

            <button
              type="submit"
              className="w-full bg-[#101b45] text-white py-3 rounded-lg font-semibold text-lg hover:bg-[#0e1734] transition shadow-md hover:shadow-lg"
            >
              Place Order
            </button>
          </form>
        </div>
      </div>

      <Modal
        isOpen={isModalSuccessOpen}
        mw="max-w-2xl"
        onClose={() => setIsModalSuccessOpen(false)}
      >
        <center>
          <h2 className="text-2xl font-semibold text-center text-[#6cb34e] mb-4">
            Order Submitted Successfully!
          </h2>
          <p className="text-gray-600 mb-6">
            Thank you for your order. We’ll process it shortly.
          </p>
          <button
            onClick={() => setIsModalSuccessOpen(false)}
            className="bg-[#6cb34e] text-white px-5 py-2 rounded-lg hover:bg-[#0e1734] transition"
          >
            OK
          </button>
        </center>
      </Modal>
    </div>
  );
};

export default ProductCheckOut;
